import { useMemo } from 'react'

import { useAppQuery } from '@/helpers/api/query'
import { createInstance } from '@/helpers/api/base'
import { useGetHubs } from '@/modules/Workstation/api/useGetHubs'
import { useGarageStore } from '@/modules/FindGarage'
import { useAuthStore } from '@/store/auth-store'
import { Role } from '@/types/auth'
import { Log } from '@/types/logs'

export const GET_FLAGGED_LOGS_KEY = 'flaggedLogs'

export const useGetFlaggedLogs = () => {
    const { role } = useAuthStore()
    const { garage } = useGarageStore()
    const { data: hubs = [] } = useGetHubs(true)

    const routesToLoad = useMemo(() => {
        if (role === Role.MileageClerk) {
            return garage?.routes ?? []
        }

        return hubs.flatMap((hub) => hub.workstations.flatMap((ws) => ws.routes.map((r) => r.route)))
    }, [role, garage, hubs])

    return useAppQuery<Log[]>({
        queryKey: [GET_FLAGGED_LOGS_KEY, routesToLoad],
        queryFn: ({ queryKey, signal }) =>
            createInstance({
                url: '/controller-logs/flagged',
                method: 'GET',
                params: {
                    Routes: queryKey[1] as string[],
                },
                paramsSerializer: {
                    indexes: null,
                },
                signal,
            }),
        enabled: routesToLoad.length > 0,
        refetchInterval: 1000 * 60,
        refetchIntervalInBackground: true,
    })
}
